module.exports = __webpack_public_path__ + "static/media/pic-2.b56f5d1c.jpg";